// extracted by mini-css-extract-plugin
export var sliderRange = "_mk-2";
export var sliderRoot = "_mk-0";
export var sliderThumb = "_mk-3";
export var sliderTrack = "_mk-1";